import React from 'react'
import styled from '@emotion/styled'
import { DiagnosisReviewItem, DiagnosisSource } from '@fusion-advantage/formlib'
import { V2L1SmallRoundIcon } from '../../uiv2/Indicator/V2L1SmallRoundIcon'
import { faClipboardList, faHexagonPlus, faMemoPad, faPrescription } from '@fortawesome/pro-solid-svg-icons'
import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { L1SmallIconButton } from './L1Button'
import { FusionColor } from '../../../theme/FusionStyle'

const L1DiagnosisReviewRowSourceRoot = styled.div({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'flex-start',
	alignItems: 'center',
})

interface L1DiagnosisReviewSourceProps {
	model: DiagnosisReviewItem
}

export const L1DiagnosisReviewRowSource = ({model}: L1DiagnosisReviewSourceProps) => {
	let icon = <V2L1SmallRoundIcon />
	switch(model.source) {
		case DiagnosisSource.DxHistory:
			icon = <V2L1SmallRoundIcon icon={faClock} />
			break
		case DiagnosisSource.Adhoc:
			icon = <V2L1SmallRoundIcon icon={faHexagonPlus} />
			break
	}
	return (
		<L1DiagnosisReviewRowSourceRoot>
			{icon}
		</L1DiagnosisReviewRowSourceRoot>
	)
}

const L1DiagnosisReviewRowEvidenceRoot = styled.div(({theme}) => ({
	display: 'flex',
	justifyContent: 'flex-start',
	gap: theme.spacing(1),
	alignContent: 'center',
	alignItems: 'center',
	flexDirection: 'row'
}))

interface L1DiagnosisReviewRowEvidenceProps {
	model: DiagnosisReviewItem
	onDxEvidenceClick?: React.MouseEventHandler<HTMLButtonElement>
	onRxEvidenceClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const L1DiagnosisReviewRowEvidence = ({model, onDxEvidenceClick, onRxEvidenceClick}: L1DiagnosisReviewRowEvidenceProps) => {
	return (
		<L1DiagnosisReviewRowEvidenceRoot>
			<L1SmallIconButton
				icon={faClipboardList}
				color={FusionColor.White}
				onClick={model.dxEvidence ? onDxEvidenceClick : undefined}
				disabled={!model.dxEvidence}
			/>
			<L1SmallIconButton
				icon={faPrescription}
				color={FusionColor.White}
				onClick={model.rxEvidence ? onRxEvidenceClick : undefined}
				disabled={!model.rxEvidence}
			/>
			{/* <L1PlainIconButton
				onClick={model.source === DiagnosisSource.Adhoc ? handleCommentClick : () => {}}
				color={model.source === DiagnosisSource.Adhoc ? (comments && comments.length > 0 ? FusionColor.White : FusionColor.BlueMain) : FusionColor.White}
				backgroundColor={model.source === DiagnosisSource.Adhoc ? (comments && comments.length > 0 ? FusionColor.BlueMain : FusionColor.White) : FusionColor.Second}
				icon={faComment}
				radius={ButtonRadius.md}
				padding={theme.spacing(1.5)}
				border={model.source === DiagnosisSource.Adhoc ? (comments && comments.length > 0 ? 'none' : `1px solid ${theme.colors.lines}`) : FusionColor.Second}
			/> */}
		</L1DiagnosisReviewRowEvidenceRoot>
	)
}

interface L1DiagnosisReviewAuditCommentButtonProps {
	model: DiagnosisReviewItem
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
	requiresAction?: boolean
}

export const L1DiagnosisReviewAuditCommentButton = ({model, onClick, requiresAction = false}: L1DiagnosisReviewAuditCommentButtonProps) => {
	let color = FusionColor.White
	if(model.auditComments.length > 0) {
		color = FusionColor.BlueMain
	}
	return (
		<L1SmallIconButton
			icon={faMemoPad}
			color={color}
			onClick={onClick}
			notification={requiresAction}
		/>
	)
}
